import LoadingActionTypes from "./action-types.ts";

const stateInicial = {
    loading: false,
};

const loadingReducer = (state = stateInicial, action) => {
    switch (action.type) {
        case LoadingActionTypes.LOADING:
            return { ...state, loading: action.payload.loading };
        default: 
            return state;
    }
}

export default loadingReducer;